import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { RootState } from '../../store/state';
import { ModalName } from '../models/modal';
import EditJobModal from '../../jobs/containers/modals/EditJobModal';
import { CloseModal } from '../../store/actions/modal.action';
import ReassignModal from '../../jobs/containers/modals/ReassignModal';
import ViewJobImagesModal from '../../jobs/containers/modals/ViewJobImagesModal';
import ConfirmationModal from '../components/ConfirmationModal';
import AddJobModal from '../../jobs/containers/modals/AddJobModal';
import { ResetUpdateJobState } from '../../jobs/actions';
import { Job } from '../models/jobs';
import OrgHierarchyModal from '../components/orgHierarchy/OrgHierarchyModal';
import EditOrgModal from '../../auth/components/EditOrgModal';
import ViewChatModal from '../../chat/components/ViewChatModal';

export interface ModalProps extends DispatchProp {
  name: ModalName;
  data: any;
}

const Modal = ({ name, data, dispatch }: ModalProps) => {

  const handleBaseClose = () => {
    dispatch(new CloseModal());
  };

  const handleJobModalClose = () => {
    dispatch(new ResetUpdateJobState());
    handleBaseClose()
  };

  switch (name) {
    case ModalName.DuplicateJob: {
      const metadata = data?.job?.metadata;
      const job: Job = {
        ...data?.job,
      };
      if (metadata) {
        const apptFromIndex = metadata?.findIndex(meta => meta.n === 'appt_from');
        const apptToIndex = metadata?.findIndex(meta => meta.n === 'appt_to');
        const nowTs = Date.now();
        const newMetadata = [...metadata];
        if (newMetadata?.[apptFromIndex]?.v && newMetadata?.[apptFromIndex]?.v < nowTs) {
          newMetadata[apptFromIndex].v = nowTs;
        }
        if (newMetadata?.[apptToIndex]?.v && newMetadata?.[apptToIndex]?.v < nowTs) {
          newMetadata[apptToIndex].v = nowTs;
        }
        job.metadata = newMetadata;
      }

      return <AddJobModal show close={handleJobModalClose} job={job}/>
    }
    case ModalName.EditJob:
      return <EditJobModal show close={ handleJobModalClose } job={ data?.job } />
    case ModalName.ReassignJob:
      return <ReassignModal show close={ handleJobModalClose } jobs={ data?.jobs }/>
    case ModalName.ViewJobImages:
      return <ViewJobImagesModal show close={ handleJobModalClose } job={ data?.job } />
    case ModalName.Confirmation:
      return <ConfirmationModal show close={ handleJobModalClose } { ...data } />
    case ModalName.EditOrg:
      return <EditOrgModal show close={handleBaseClose} org={data?.org} />
    case ModalName.ViewChat:
      return <ViewChatModal show close={handleBaseClose} job={data?.job} />
    case ModalName.OrgHierarchy:
      return <OrgHierarchyModal show close={handleBaseClose} />
    default:
      return null;
  }
};

const mapStateToProps = (state: RootState) => ({
  name: state?.modal?.name,
  data: state?.modal?.data,
});

export default connect(mapStateToProps)(Modal);
